export default "__VITE_ASSET__BpZywz_P__"